const actions = {
	
	FETCH_COUNTRIES_BEGIN: 'FETCH_COUNTRIES_BEGIN',
	FETCH_COUNTRIES_SUCCESS: 'FETCH_COUNTRIES_SUCCESS',
	FETCH_COUNTRIES_ERR: 'FETCH_COUNTRIES_ERR',

	FETCH_STATES_BEGIN: 'FETCH_STATES_BEGIN',
	FETCH_STATES_SUCCESS: 'FETCH_STATES_SUCCESS',
	FETCH_STATES_ERR: 'FETCH_STATES_ERR',

	FETCH_CITIES_BEGIN: 'FETCH_CITIES_BEGIN',
	FETCH_CITIES_SUCCESS: 'FETCH_CITIES_SUCCESS',
	FETCH_CITIES_ERR: 'FETCH_CITIES_ERR',

	fetchCountriesBegin: () => {
		return {
			type: actions.FETCH_COUNTRIES_BEGIN,
		};
	},

	fetchCountriesSuccess: (data) => {
		return {
			type: actions.FETCH_COUNTRIES_SUCCESS,
			data,
		};
	},

	fetchCountriesErr: (err) => {
		return {
			type: actions.FETCH_COUNTRIES_ERR,
			err,
		};
	},

	fetchStatesBegin: () => {
		return {
			type: actions.FETCH_STATES_BEGIN,
		};
	},

	fetchStatesSuccess: (data) => {
		return {
			type: actions.FETCH_STATES_SUCCESS,
			data,
		};
	},

	fetchStatesErr: (err) => {
		return {
			type: actions.FETCH_STATES_ERR,
			err,
		};
	},

	fetchCitiesBegin: () => {
		return {
			type: actions.FETCH_CITIES_BEGIN,
		};
	},

	fetchCitiesSuccess: (data) => {
		return {
			type: actions.FETCH_CITIES_SUCCESS,
			data,
		};
	},

	fetchCitiesErr: (err) => {
		return {
			type: actions.FETCH_CITIES_ERR,
			err,
		};
	},
};

export default actions;
